export const MAX_ZOOM = 20;
export const MAX_ANNOTATION_ZOOM = 5;
export const MIN_ZOOM = 1;

/** Marks the asset-modal clip image used for canvas ↔ modal view-transition morphs. */
export const ASSET_MODAL_MORPH_HERO_IMAGE_ATTRIBUTE = 'data-asset-modal-morph-hero-image';

export const ASSET_MODAL_MORPH_HERO_IMAGE_SELECTOR = `[${ASSET_MODAL_MORPH_HERO_IMAGE_ATTRIBUTE}]`;
